import script from "./EditTagForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EditTagForm.vue?vue&type=script&setup=true&lang=js"

import "./EditTagForm.vue?vue&type=style&index=0&id=a4a0fdc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4a0fdc6"]])

export default __exports__